module.exports = __webpack_public_path__ + "static/reason_global-4871f4fb6cfbdf33f26386baf7158af1.png";